/* import __COLOCATED_TEMPLATE__ from './starting-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();